export enum ViewType {
  fullAddress = 'fullAddress',
  moneyGiftAddress = 'moneyGiftAddress',
  subFullAddress = 'subFullAddress',
  shortAddress = 'shortAddress',
  nameOnly = 'nameOnly',
}
